// 转弯方向
export enum TurnDirection {
  Left = 'Left',
  Right = 'Right',
}

// 转弯类型 (AR-2 三档分类)
export enum TurnType {
  Skidding = 'Skidding',  // 搓雪
  Edging = 'Edging',      // 走刃
  Carving = 'Carving',    // 卡宾
}

// 弯时长分类 (AR-1)
export enum TurnDuration {
  Short = 'Short',    // <500ms
  Medium = 'Medium',  // 500-1500ms
  Long = 'Long',      // >=1500ms
}

// 评估等级 (AR-6 五档)
export enum EvaluationLevel {
  Excellent = 'Excellent',      // >=90
  Good = 'Good',                // 75-89
  Average = 'Average',          // 60-74
  BelowAverage = 'BelowAverage', // 40-59
  Poor = 'Poor',                // <40
}

// 运动类型
export enum SportType {
  OutdoorSki = 'OutdoorSki',
  IndoorSki = 'IndoorSki',
  DrySlope = 'DrySlope',
}

// 雪道难度
export enum SlopeDifficulty {
  Green = 'Green',
  Blue = 'Blue',
  Red = 'Red',
  Black = 'Black',
}

// SM-1 回放主流程状态
export enum PlaybackState {
  Loading = 'Loading',
  Ready = 'Ready',
  Playing = 'Playing',
  PausedInTurn = 'PausedInTurn',
  PausedBetweenTurns = 'PausedBetweenTurns',
  Ended = 'Ended',
}

// SM-1 Loading 子状态
export enum LoadingSubState {
  LoadingData = 'LoadingData',
  LoadingValidate = 'LoadingValidate',
  LoadingError = 'LoadingError',
}

// SM-2 虚拟硬件状态
export enum VirtualHardwareState {
  Idle = 'Idle',
  ManualControl = 'ManualControl',
  PresetPlaying = 'PresetPlaying',
}

// SM-3 语音播报状态
export enum VoiceState {
  Silent = 'Silent',
  Speaking = 'Speaking',
  Paused = 'Paused',
}

// SM-4 诊断面板状态
export enum DiagnosticPanelState {
  Hidden = 'Hidden',
  Appearing = 'Appearing',
  Visible = 'Visible',
  Updating = 'Updating',
  Disappearing = 'Disappearing',
}

// AR-7 摔倒检测状态机
export enum FallDetectionState {
  Normal = 'Normal',
  FreeFall = 'FreeFall',
  Impact = 'Impact',
  Stationary = 'Stationary',
}

// 摔倒检测灵敏度
export enum FallSensitivity {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

// 可视化通道
export enum VisualizationChannel {
  Pressure = 'Pressure',
  Edging = 'Edging',
  Gyroscope = 'Gyroscope',
  Acceleration = 'Acceleration',
  Speed = 'Speed',
}

// 视角预设
export enum ViewPreset {
  Front = 'Front',
  Side = 'Side',
  Top = 'Top',
  Free = 'Free',
}

// 配色方案
export enum ColorSchemeId {
  Default = 'default',
  Ice = 'ice',
  Viridis = 'viridis',
  Inferno = 'inferno',
  Colorblind = 'colorblind',
}
